export const getIntialValues = (data = {}) => ({
  meta_seo: {
    meta_title: data?.meta_seo?.meta_title || "",
    meta_keyword: data?.meta_seo?.meta_keyword || "",
    meta_desc: data?.meta_seo?.meta_desc || "",
    meta_slug_url: data?.meta_seo?.meta_slug_url || "",
  },
  hero_banner: {
    heading: {
      white: data?.hero_banner?.heading?.white || "",
      orange: data?.hero_banner?.heading?.orange || "",
    },
    subHeading: data?.hero_banner?.subHeading || "",
    paragraphs: data?.hero_banner?.paragraphs || ["", ""],
    image: data?.hero_banner?.image || "",
    cta_title: data?.hero_banner?.cta_title || "",
    cta_download: data?.hero_banner?.cta_download || "",
    cta_download_second: data?.hero_banner?.cta_download_second || "",
  },
  energy_solutions: {
    heading: {
      white: data?.energy_solutions?.heading?.white || "",
      orange: data?.energy_solutions?.heading?.orange || "",
    },
    subHeading: data?.energy_solutions?.subHeading || "",
    para: data?.energy_solutions?.para || [""],
    sections: data?.energy_solutions?.sections || [
      { title: "Residential", align: "left", image: "", alt: "", btn_cta: "", btn_link: "" },
      { title: "Industrial", align: "right", image: "", alt: "", btn_cta: "", btn_link: "" },
    ],
  },
  about_us: {
    heading: {
      white: data?.about_us?.heading?.white || "",
      orange: data?.about_us?.heading?.orange || "",
    },
    sub_heading: data?.about_us?.sub_heading || "",
    desc: data?.about_us?.desc || "",
    sub_desc: data?.about_us?.sub_desc || "",
    cards: data?.about_us?.cards || [{ icon: "", text: "" }],
    bottom_para: data?.about_us?.bottom_para || "",
  },
  residential_industrial: {
    heading: {
      white: data?.residential_industrial?.heading?.white || "",
      orange: data?.residential_industrial?.heading?.orange || "",
    },
    sub_heading: data?.residential_industrial?.sub_heading || "",
    description: data?.residential_industrial?.description || "",
    sections: data?.residential_industrial?.sections?.map((section) => ({
      title: section?.title || "",
      highlight: section?.highlight || "",
      sub_title: section?.sub_title || "",
      description: section?.description || "",
      image: section?.image || "",
      image_alt: section?.image_alt || "",
      checklist: section?.checklist || [],
      extra_description: section?.extra_description || "",
      advantages_title: section?.advantages_title || "",
      features: section?.features || [],
      cta_title: section?.cta_title || "",
      cta_link: section?.cta_link || "",
      bottom_description: section?.bottom_description || "",
    })) || [
        {
          title: "",
          highlight: "",
          sub_title: "",
          description: "",
          image: "",
          image_alt: "",
          checklist: [{ text: "" }],
          extra_description: "",
          advantages_title: "",
          features: [{ text: "", icon: "" }],
          cta_title: "",
          cta_link: "",
          bottom_description: "",
        },
      ],
  },


  why_enclave: {
    heading: data?.why_enclave?.heading || "",
    heading_orange: data?.why_enclave?.heading_orange || "",
    sub_heading: data?.why_enclave?.sub_heading || "",
    description: data?.why_enclave?.description || "",
    drivers_title: data?.why_enclave?.drivers_title || "",
    drivers: data?.why_enclave?.drivers || [{ text: "" }],
    bottom_para_1: data?.why_enclave?.bottom_para_1 || "",
    bottom_para_2: data?.why_enclave?.bottom_para_2 || "",
  },
  location_section: {
    heading: data?.location_section?.heading || "",
    heading_orange: data?.location_section?.heading_orange || "",
    sub_heading: data?.location_section?.sub_heading || "",
    description: data?.location_section?.description || "",
    map_image: data?.location_section?.map_image || "",
    tabs: data?.location_section?.tabs?.length
      ? data.location_section.tabs.map((tab) => ({
        label: tab?.label || "",
        value: tab?.value || "",
        banner_image: tab?.banner_image || "",
        title: tab?.title || "",
        points: tab?.points || [],
      }))
      : [
        {
          label: "Residential",
          value: "residential",
          banner_image: "",
          title: "",
          points: [{ text: "" }],
        },
        {
          label: "Industrial",
          value: "industrial",
          banner_image: "",
          title: "",
          points: [{ text: "" }],
        },
      ],
  },
  slider_section: {
    heading: {
      white: data?.slider_section?.heading?.white || "",
      orange: data?.slider_section?.heading?.orange || "",
    },
    subHeading: data?.slider_section?.subHeading || "",
    description: data?.slider_section?.description || "",
    cards: data?.slider_section?.cards || [{ img: "", title: "", desc: "" }],
  },
  logo_slider: {
    heading: {
      white: data?.logo_slider?.heading?.white || "",
      orange: data?.logo_slider?.heading?.orange || "",
    },
    subHeading: data?.logo_slider?.subHeading || "",
    para: data?.logo_slider?.para || [""],
    logos: data?.logo_slider?.logos || [{ image: "", alt: "" }],
  },
  footer_bgimg: data?.footer_bgimg || "",
});

export const generatePayload = (values) => {
  const { _id, createdAt, updatedAt, __v, ...payload } = values;
  return payload;
};